import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { DoubleOptInPage } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInPage'
import { DoubleOptInLayout } from 'pages/settings/pages/doubleOptIn/layout/DoubleOptInLayout'
import { DoubleOptInAccessLayout } from 'pages/settings/pages/doubleOptIn/layout/DoubleOptInAccessLayout'

export const DoubleOptInRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<DoubleOptInAccessLayout />}>
        <Route element={<DoubleOptInLayout />}>
          <Route path={'/'} element={<DoubleOptInPage />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
